import { IOffer } from '../../../types/offer';

export function getDailyHouseTitle(offer: IOffer) {
  return offer.isRentByParts && offer.rentByPartsDescription ? offer.rentByPartsDescription + ' дома' : 'Дом';
}
